export const inspectTable_1 = [
  {
    content: "작업현장 내 유해하거나 위험한 장소·시설·물질에 대한 경고, 비상시에 대처하기 위한 지시·안내 등의 표지를 작업자가 알아보기 쉽도록 부착하여야 한다.",
    isChecked: "",
    title: "안전보건 표지",
  },
  {
    content: "안전보건표지는 각각 위험을 경고하는 그림과 문구를 포함하고 있어야 한다.",
    isChecked: "",
    title: "안전보건 표지",
  },
  {
    content: "표지의 제작은 금지, 경고, 지시, 안내 등 표지의 용도에 맞는 모형, 색상, 심볼, 문구를 사용한다",
    isChecked: "",
    title: "안전보건 표지",
  },
  {
    content: "현장에 설치된 안전표지들이 장애물로부터 시야를 가리지 않도록 해야 한다.",
    isChecked: "",
    title: "안전보건 표지",
  },
  {
    content: "경고표지는 강화 알루미늄, 강화 플라스틱, PVC 등 쉽게 파손되거나 변질되지 않는 소재로 제작되어야 하고, 현장의 상황을고려하여 반사되거나 발광하게 할 수 있다.",
    isChecked: "",
    title: "안전보건 표지",
  },
  {
    content: "작업별 유해·위험 요인을 파악하여 안전한 작업계획을 수립한다.",
    isChecked: "",
    title: "작업 전 작업",
  },
  {
    content: "작업을 수행하는 작업자에게 각 작업의 유해·위험요인 및 위험상황 발생 시 대처요령을 주지시킨다. ",
    isChecked: "",
    title: "작업 전 작업",
  },
  {
    content: "각 유해·위험작업에 대한 관리자를 지정하고, 관리자의 지도·감독 하에 작업을 수행한다.",
    isChecked: "",
    title: "작업 전 작업",
  },
  {
    content: "유해·위험 작업별 필요한 보호구를 파악하고, 작업자에게 지급·착용하도록 한다.",
    isChecked: "",
    title: "보호구",
  },
];
export const inspectTable_2 = [
  {
    content: "화재위험작업에 대한 작업계획을 수립한다.",
    isChecked: "",
    title: "작업 전 확인사항",
  },
  {
    content: "작업장 내 위험물, 가연물의 사용·보관 현황을 파악한다.",
    isChecked: "",
    title: "작업 전 확인사항",
  },
  {
    content: "위험물질로 인한 응급상황이 발생했을 때 필요한 행동에 대한 정보를 미리 준비하고 있어야 한다.",
    isChecked: "",
    title: "작업 전 확인사항",
  },
  {
    content: "작업현장에 허가받은 위험물의 종류별 기준량 이상이 되면 지역 소방기관과 관계기관에 신고해야 한다.",
    isChecked: "",
    title: "작업 전 확인사항",
  },
  {
    content: "소방서로부터 허가받은 위험물 제조소 또는 저장소 자료를 토대로 현장에 위험물의 종류별로 기준 이상의 위험물이 존재하거나 앞으로 존재하게 될것인지의 여부를<br/>" + "      판단해야 한다.",
    isChecked: "",
    title: "작업 전 확인사항",
  },
  {
    content: "작업자에 대해 화재예방 및 피난 교육 등을 실시한다.",
    isChecked: "",
    title: "작업 전 확인사항",
  },
  {
    content: "화재위험작업 대상 작업자에게 특별안전보건교육을 실시한다.",
    isChecked: "",
    title: "작업 전 확인사항",
  },
  {
    content: "산소, LPG 등 가스 용기는 전도 위험이 없는 곳에 보관하며, 사용 전 또는 사용 중인 용기와 그 밖의 용기를 명확히 구별하여 보관한다.",
    isChecked: "",
    title: "가스 등의 가연물의 관리",
  },
  {
    content: "작업을 중단하거나 마치고 작업장소를 떠날 경우에는 가스 등의 공급구의 밸브나 콕을 잠근다.",
    isChecked: "",
    title: "가스 등의 가연물의 관리",
  },
  {
    content: "인화성 가스 및 산소를 사용하여 금속을 용접·용단하는 경우, 지정된 자격증*의 보유 여부를 확인한다.<br/>" + "      *전기용접기능사, 특수용접기능사 및 가스용접기능사보 등",
    isChecked: "",
    title: "용접·용단 작업",
  },
  {
    content: "작업자의 대피를 유도하는 업무만을 담당하는 화재감시자를 지정하여 용접·용단 작업 장소에 배치하여야 한다.",
    isChecked: "",
    title: "용접·용단 작업",
  },
  {
    content: "주변 가연성물체에 불꽃이 튀지 않도록 용접불티 비산방지덮개, 용접방화포 등을 설치 및 소화기구를 비치하여 작업한다.",
    isChecked: "",
    title: "용접·용단 작업",
  },
  {
    content: "불꽃이 발생될 우려가 있는 작업을 하는 경우 주변에 가연물*, 인화성 액체는 화재위험이 없는 장소에 별도로 보관·저장한다.<br/>" + "*합성섬유, 합성수지, 면, 양모, 천조각, 톱밥, 짚, 종이류 또는 인화성 액체 등",
    isChecked: "",
    title: "용접·용단 작업",
  },
];
export const inspectTable_3 = [
  {
    content: "감전위험이 있는 전기 기계·기구 또는 전로의 설치·해체·정비·점검 등의 작업을 하는 하는 경우 작업자의 자격을 확인한다.",
    isChecked: "",
    title: "자격 및 보호구의 확인",
  },
  {
    content: "감전의 위험이 있는 작업에 종사하는 경우 절연용 보호구를 지급하고 작업자에게 착용하도록 한다.",
    isChecked: "",
    title: "자격 및 보호구의 확인",
  },
  {
    content: "가공전로에 근접하여 비계를 설치하는 경우에는 가공전로를 이설하거나 가공전로에 절연용 방호구를 장착하는 등 가공전로와의 접촉을 방지하기 위해조치 한다.",
    isChecked: "",
    title: "가공전로 및 임시 수전설비",
  },
  {
    content: "임시 수전설비의 주변은 관계 작업자가 아닌 사람의 출입을 금지하고, 위험표시 등의 방법으로 방호를 강화한다.",
    isChecked: "",
    title: "가공전로 및 임시 수전설비",
  },
  {
    content: "가설 배전반·분전반은 충전부가 노출되지 않도록 폐쇄형 외함이 있는 구조로 설치한다. ",
    isChecked: "",
    title: "배전반·분전반 설치 및 관리",
  },
  {
    content: "충전부는 충분한 절연효과가 있는 방호망이나 절연덮개를 설치한다.",
    isChecked: "",
    title: "배전반·분전반 설치 및 관리",
  },
  {
    content: "분전반 등 전기 기계·기구의 금속제 외함, 금속제 외피 및 철대는 접지를 실시한다.",
    isChecked: "",
    title: "배전반·분전반 설치 및 관리",
  },
  {
    content: "배선 또는 이동전선의 절연피복이 손상되거나 노화됨으로 인한 감전의 위험을 방지하기 위한 조치를 하여야 한다.",
    isChecked: "",
    title: "현장 이동식 케이블(전선) 관리",
  },
  {
    content: "습윤한 장소의 이동전선 및 부속 접속기구는 충분한 절연효과가 있는 것을 사용한다.",
    isChecked: "",
    title: "현장 이동식 케이블(전선) 관리",
  },
  {
    content: "통로바닥에 전선 또는 이동전선 등을 설치하여 사용하지 않도록 관리한다.",
    isChecked: "",
    title: "현장 이동식 케이블(전선) 관리",
  },
  {
    content: "코드와 플러그를 접속하여 사용하는 비충전 금속체의 기계·기구의 접지를 확인한다.",
    isChecked: "",
    title: "이동식 전기기계 기구사용",
  },

  {
    content: "휴대형 또는 이동형 전동기계의 전원에 누전차단기를 설치하고 그 작동여부를 점검한다.",
    isChecked: "",
    title: "이동식 전기기계 기구사용",
  },

  {
    content: "누전차단기는 분기회로 또는 전기기계·기구마다, 배전반 및 분전반 등 누전차단기의 파손을 예방할 수 있는 장소에 접속한다.",
    isChecked: "",
    title: "이동식 전기기계 기구사용",
  },
];
export const inspectTable_4 = [
  {
    content: "현장 내 밀폐공간의 위치를 파악하고, 밀폐공간의 질식·중독을 일으킬 수 있는 요인*을 파악하여 밀폐공간 작업 프로그램을 수립한다.<br/>" + "       *산소결핍, 황화수소, 일산화탄소, 이산화탄소 등",
    isChecked: "",
    title: "작업 전 확인사항",
  },
  {
    content: "산소 및 유해가스 측정기, 환기팬, 공기호흡기, 송기마스크의 보유여부를 확인한다.",
    isChecked: "",
    title: "작업 전 확인사항",
  },
  {
    content: "콘크리트 보온양생이 필요한 경우, 갈탄·숯탄 등 연료 대신 전기열풍기를 사용한다.",
    isChecked: "",
    title: "작업 시 안전조치",
  },
  {
    content:
      "밀폐공간 작업 전, 작업 중 산소 및 유해가스 농도를 측정하고 적정공기* 상태인지 확인한다.<br/>" + "       *① 산 소 : 18.0 ~ 23.5%  ② 황화수소 : 10 ppm 미만 <br/>" + "         ③\t 탄산가스(이산화탄소) : 1.5% 미만  ④ 일산화탄소 : 30 ppm미만",
    isChecked: "",
    title: "작업 시 안전조치",
  },
  {
    content: "적정공기 상태가 아닌 경우 작업장을 환기시키거나, 작업자에게 공기호흡기 또는 송기마스크를 지급하여 착용하도록 한다.",
    isChecked: "",
    title: "작업 시 안전조치",
  },
  {
    content: "작업 전과 작업 중에 환기팬을 이용하여 환기한다.",
    isChecked: "",
    title: "작업 시 안전조치",
  },
  {
    content: "밀폐공간 입구에는 출입금지 표지를 부착하고 작업자의 무단출입을 금지하며, 밀폐공간 외부에 감시인을 배치한다.",
    isChecked: "",
    title: "작업 시 안전조치",
  },
  {
    content: "밀폐공간에 입장시킬 때와 퇴장시킬 때마다 인원을 점검한다.",
    isChecked: "",
    title: "작업 시 안전조치",
  },
  {
    content: "현장내 밀폐공간의 위치, 작업 전 작업자와 감시인에게 안전작업하는 방법을 교육한다.<br/>" + "       *유해가스 측정, 환기설비 가동, 보호구 착용, 사고시 응급조치, 구조요청 절차 등",
    isChecked: "",
    title: "안전교육",
  },
  {
    content: "밀폐공간에서 사고 발생 시 119 구조대가 오기 전까지는 공기호흡기나 산소마스크를 착용하지 않은 상태에서는 절대 구조하러 들어가지 않도록 교육한다.",
    isChecked: "",
    title: "안전교육",
  },
];
